import { render, staticRenderFns } from "./OneMinuteList.vue?vue&type=template&id=50fd8198&scoped=true"
import script from "./OneMinuteList.vue?vue&type=script&lang=js"
export * from "./OneMinuteList.vue?vue&type=script&lang=js"
import style0 from "./OneMinuteList.vue?vue&type=style&index=0&id=50fd8198&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50fd8198",
  null
  
)

export default component.exports